import React from 'react';
import { Chatbot, IngestWithContext, Configuration, type TChatConfig } from '@wealthlane/chatbot2';
import { axiosInstance } from '../../services/apiInterceptor';
import { useGetCurrentTenantInfo, useWealthlaneCustomerApi } from '../../hooks';

export const configState: TChatConfig = {
  responseProtocol: 'websocket' as const as string,
  responseType: 'stream' as const as string,
  endpoint: process.env.REACT_APP_CHATBOT_WEBSOCKET_API,
  timeout: 30000,
  ingestionEndpoint: process.env.REACT_APP_INGESTION_ENDPOINT,
};

function IngestComponent() {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: currentTenantInfo } = useGetCurrentTenantInfo(handleRequest);

  return (
    <IngestWithContext
      headers={{
        url: process.env.REACT_APP_INGESTION_ENDPOINT,
        customerName: currentTenantInfo?.companyName,
        source: 'customer',
      }}
      axiosInstance={axiosInstance}
      config={configState}
      companyId={currentTenantInfo?.companyId}
    />
  );
}

export const Ingest = IngestComponent;
export default IngestComponent;
